import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getDeviceUrl } from 'util/device';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';
import useDevices from 'store/devices';
import useAlarmsStore from 'store/alarms';
import CircuitTableControllerRow from './circuit-table-controller-row';
import { getMaxSeverity } from 'store/alarms';
import { LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import StatusIcon from 'components/status-icon';


/**
 * @function CircuitTableRow
 * @memberof module:CircuitTable
 *
 * @param {object} props
 * @param {object} props.circuit Device model
 * @returns {React.ReactElement}
 */
function CircuitTableRow({row, selectedRows, toggleRow}) {
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();
  const [devicesStore, devicesStoreActions] = useDevices();
  const [loading, setLoading] = useState();
  const [alarmsStore] = useAlarmsStore();
  const [status, setStatus] = useState();

  const alarms = alarmsStore.alarms.filter(alarm => alarm.deviceId == row.id);

  if (row.type == 'Controller') return (<CircuitTableControllerRow row={row} />);

  useEffect(() => {
    setLoading(true);

    devicesStoreActions.fetchStatus(row.id).then((status) => {
      setStatus(status);
      setLoading(false);
    });
  }, [row]);

  return (
    <tr>
      <td>
        {usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles) ? <input
          type="checkbox"
          checked={selectedRows.includes(row)}
          onChange={() => toggleRow(row)}
          onClick={event => event.stopPropagation()}
        /> : null}
        {loading ?
          <LoadingIndicator show={true} /> :
          <StatusIcon
            device={devicesStore.shallowDevices.get(row.id)}
            alarms={alarms}
            commStatus={row.commStatus}
          />
        }
        <Link to={getDeviceUrl(devicesStore.shallowDevices.get(row.id))}>
          {row.name}
        </Link>
      </td>
      <td>{status?.temperature == null ? <>&ndash;</> : status.temperature}&#176;{status ? status.temperatureUnit : null}</td>
      <td>{status?.current == null ? <>&ndash;</> : status.current}A</td>
      <td>{status?.groundCurrent == null ? <>&ndash;</> : status.groundCurrent}mA</td>
      <td>{status?.powerDelivery == null ? <>&ndash;</> : status.powerDelivery}%</td>
    </tr>
  )
}

export default CircuitTableRow;
